module.exports = __webpack_public_path__ + "static/media/Practice2.836abdf2.bmp";